import React from "react";
import { FrameContext } from "../../contexts/FrameContext";
import firebaseApi from "../../apis/firebaseApi";
import DayAppointments from "../common/DayAppointments";

const AgentSchedule = () => {
    const { companyId, agentId, refresh } = React.useContext(FrameContext);
    const [schedules, setSchedules] = React.useState();

    React.useEffect(() => {
        if (!companyId || !agentId) return;

        firebaseApi.getPendingAgentSchedules(companyId, agentId, data => {
            let items = [];
            data.forEach(x => items.push({ ...x.data(), id: x.id }));
            setSchedules(items);
        })
    }, [companyId, agentId, refresh]);

    if (!schedules) return null;

    const groups = schedules.reduce((groups, schedule) => {
        const date = new Date(schedule.schedule.startTime * 1000);
        const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        if (!groups[dateOnly]) {
          groups[dateOnly] = [];
        }
        groups[dateOnly].push(schedule);
        return groups;
      }, {});
      
      // Edit: to add it in the array format instead
      const groupArrays = Object.keys(groups).map((date) => {
        return {
          date: new Date(date),
          schedules: groups[date]
        };
      });

    return (
        <div>
            {/* {!isInFrame() && <h3 className="text-center">Schedule</h3>} */}
            <div className="pf-schedule-schedule-container">
                {schedules.length === 0 &&
                    <div className="text-center">You have no upcoming appointments.</div>
                }
                {groupArrays.map(x =>
                    <DayAppointments date={x.date} schedules={x.schedules} />
                )}
            </div>
        </div>
    );
}

export default AgentSchedule;